module.exports = __webpack_public_path__ + "static/google-play-052ce8256f74b537543e874332092e76.svg";